import {BrokerMarketStatus} from 'modules/decisionsNext/api/types';

export const FILTER_PANEL_FOOTER_ID = 'filter-panel-footer';

export enum MarketPlacement {
  All = 'All',
  Direct = 'Direct',
  Indirect = 'Indirect',
}

export const marketPlacementOptions = [
  {
    label: 'All',
    value: MarketPlacement.All,
  },
  {
    label: 'Direct',
    value: MarketPlacement.Direct,
  },
  {
    label: 'Indirect',
    value: MarketPlacement.Indirect,
  },
];

export const brokerMarketStatusesOptions = [
  {
    label: 'Strategic',
    value: BrokerMarketStatus.Strategic,
  },
  {
    label: 'Non-strategic',
    value: BrokerMarketStatus.NonStrategic,
  },
  {
    label: 'Other',
    value: BrokerMarketStatus.Other,
  },
];
